import React from "react";
import QuoteToolNavBar from "../molecules/NavBar.js";
import {Alert, Button} from "reactstrap";
import {redirectToLogin} from "../../helper/auth.helper.js";


class UserPendingPage extends React.Component {

    handleLogout = () => {
        // Server clears session on logout endpoint
        redirectToLogin();
    };

    render() {
        return (
            <>
                <div style={{textAlign: 'center', marginTop: '20px', marginLeft: '25%',  marginRight: '25%'}}>
                    <Alert>
                        <h4 className="alert-heading">
                            New User Account Pending
                        </h4>
                        <p>
                           Thank you for creating a new user account for the Quote Tool. Your account is pending approval. Please contact
                            the development team to grant your access. Once access has been granted please click the button below to login.
                        </p>
                        <hr />
                        <Button color="primary" onClick={() => this.handleLogout()}>Login</Button>
                    </Alert>
                </div>
            </>
        );
    }
}

export default UserPendingPage;
